import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import FontAwesomeIcon from '../Icon';
import { useSelector, useDispatch } from 'react-redux';
import {
  setActiveTab,
  setActiveSuiteTab,
  setActiveCommonAreaTab,
  setActiveContactTab,
  setActiveCatalogTab,
} from 'src/store/actions/activeTab';
import './Tabs.scss';
import {
  useHorizontalScrollChevrons
} from 'src/SharedCustomHooks/UseHorizontalScrollChevrons/useHorizontalScrollChevrons';

const Tabs = ({ items, activeTab, from, hideEmptyTabs = false }: any) => {
  const tabsElementRef = useRef(null);
  const dispatch = useDispatch();

  // Why in the hell is this in redux? Why not just use local state? https://trello.com/c/zsa92dIf
  const currentActiveTab = useSelector(
    (state: any) => state.activeTab?.activeTab || 0
  );
  const currentActiveSuiteTab = useSelector(
    (state: any) => state.activeTab?.suiteActiveTab || 0
  );
  const currentActiveCommonAreaTab = useSelector(
    (state: any) => state.activeTab?.commonAreaActiveTab || 0
  );
  const currentActiveContactTab = useSelector(
    (state: any) => state.activeTab?.contactActiveTab || 0
  );
  const currentActiveCatalogTab = useSelector(
    (state: any) => state.activeTab?.catalogActiveTab || 0
  );

  const incrementTabIndex = (value) => {
    if (from === 'suite') {
      setItemIndex(value);
      dispatch(setActiveSuiteTab(value));
    } else if (from === 'Property') {
      setItemIndex(value);
      dispatch(setActiveTab(value));
    } else if (from === 'CommonArea') {
      setItemIndex(value);
      dispatch(setActiveCommonAreaTab(value));
    } else if (from === 'Contact') {
      setItemIndex(value);
      dispatch(setActiveContactTab(value));
    } else if (from === 'Catalog') {
      setItemIndex(value);
      dispatch(setActiveCatalogTab(value));
    } else {
      setItemIndex(value);
    }
  };

  const getInitialItemIndex = () => {
    if (activeTab) {
      return activeTab;
    }

    if (from === 'suite') {
      return currentActiveSuiteTab;
    }

    if (from === 'Property') {
      return currentActiveTab;
    }

    if (from === 'CommonArea') {
      return currentActiveCommonAreaTab;
    }

    if (from === 'Contact') {
      return currentActiveContactTab;
    }

    if (from === 'Catalog') {
      return currentActiveCatalogTab;
    }

    return 0;
  };

  // Local component state: Todo: Refactor the Redux state above to scope it down here.
  const [itemIndex, setItemIndex] = useState(getInitialItemIndex());

  const { showLeftChevron, showRightChevron } = useHorizontalScrollChevrons({
    scrollRef: tabsElementRef,
    dependencies: [],
  });

  return (
    <div
      className={classNames('tabs', {
        'tabs--show': items.length > 1,
      })}
    >
      {items.length > 1 && (
        <div className="tabs__wrapper">
          <div className="tabs__items" ref={tabsElementRef}>
            {items.map((i: any, x: any) => {
              if (!i.label) return <></>;

              if (hideEmptyTabs && parseInt(i.count) === 0) return <></>;

              return (
                <button
                  key={x}
                  className={classNames('tabs__item', {
                    'tabs__item--active': x === itemIndex,
                  })}
                  onClick={() => incrementTabIndex(x)}
                >
                  {i.label}{' '}
                  {i.count && <span className="tabs__count">{i.count}</span>}
                </button>
              );
            })}
          </div>
          <div
            className={'tabs__fade left ' + (showLeftChevron ? '' : 'hidden')}
          >
            <FontAwesomeIcon glyph="chevron-double-left" weight="solid" />
          </div>
          <div className={'tabs__fade ' + (showRightChevron ? '' : 'hidden')}>
            <FontAwesomeIcon glyph="chevron-double-right" weight="solid" />
          </div>
        </div>
      )}
      <div className="tabs__content">
        {items
          .filter((i: any, x: any) => x === itemIndex)
          .map((i: any, x: any) => (
            <div key={x}>{i.content}</div>
          ))}
      </div>
    </div>
  );
};

export default Tabs;
